import { takeEvery, put, call } from "redux-saga/effects";
import {
  getSettingsSuccess,
  getSettingsFailure,
  updateSettingsSuccess,
  updateSettingsFailure,
} from "./actions";
import {
  getSettingsAPI,
  updateSettingsAPI,
} from "../../helpers/backend.helper";

import { UPDATE_SETTINGS, GET_SETTINGS } from "./actionTypes";

export function* getSettings() {
  try {
    const response = yield call(getSettingsAPI);
    yield put(getSettingsSuccess(response?.data));
  } catch (error) {
    yield put(getSettingsFailure(error));
  }
}

function* updateSettings({ payload: { settings } }) {
  try {
    const response = yield call(updateSettingsAPI, settings);
    yield put(updateSettingsSuccess(response?.data));
  } catch (error) {
    yield put(updateSettingsFailure(error));
  }
}

function* SettingsSaga() {
  yield takeEvery(UPDATE_SETTINGS, updateSettings);
  yield takeEvery(GET_SETTINGS, getSettings);
}

export default SettingsSaga;
